import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getInitials } from "../../../../../shared/utils/utils";
import Icon from "../../../../../shared/components/ui/icons/Icon";
import iconsList from "../../../../../shared/components/ui/icons/iconsList";
import ConfirmDeletePopup from "../../../../../shared/components/features/message/confirmDeletePopup/ConfirmDeletePopup";
import classes from "./RoleHolderRow.module.css";

const RoleHolderRow = ({ participant, onRemove, index }) => {
    const { texts } = useSelector((state) => state.translate);
    const { avatarColors } = useSelector((state) => state.uiData.general);
    const { firstName, lastName } = participant;
    const avatarColor = avatarColors?.[index % avatarColors?.length];
    const [showConfirm, setShowConfirm] = useState(false);

    const handleConfirm = () => {
        onRemove(participant);
        setShowConfirm(false);
    };

    return (
        <>
            <div className={classes.Row}>
                <div className={classes.NameCell}>
                    <div className={classes.Avatar} style={{ backgroundColor: avatarColor }}>
                        <span className={classes.Initials}>{getInitials(firstName, lastName)}</span>
                    </div>
                    <span className={classes.FullName}>{`${firstName} ${lastName}`}</span>
                </div>
                <div className={classes.ActionsCell}>

                    <Icon name={iconsList.delete} size="24px" color="#6228C1" onClick={() => setShowConfirm(true)} />
                </div>
            </div>
            {showConfirm && (
                <ConfirmDeletePopup
                    onClose={() => setShowConfirm(false)}
                    onClick={handleConfirm}
                    text={texts.confirmRemovePermissionOf}
                    confirmText={`${texts.confirmRemovePermissionOfTitle ?? ""} ${firstName} ${lastName}?`}
                />
            )}
        </>
    );
};

export default RoleHolderRow;
